export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6934.d209bd77.jpg";